import { getBalanceHub } from '@aries/aptos-defi/common';
import { getClaimSDK } from '@aries/aptos-defi/common/aries-sdk';
import { withSendTxNotify } from '@aries/aptos-defi/utils';

export const claimBorrowRebate = withSendTxNotify(
  async (rebateContractAddress: string) => {
    const res = await getClaimSDK(rebateContractAddress)
      .claim.claim()
      .execute();

    getBalanceHub()?.refresh();

    return res;
  },
);
